<template>
  <div>
    <b-modal
      v-model="showDeleteModal"
      size="sm"
      :title="$t('workflow.deleteHeaderText')"
    >
      <p>{{ $t("workflow.deleteText") }}</p>
      <template v-slot:modal-footer>
        <b-button
          size="sm"
          @click="showDeleteModal = false"
          variant="outline-danger"
        >
          {{ $t("cancelBtnText") }}
        </b-button>
        <b-button
          size="sm"
          @click="onDeleteRow(selectedRowIndex)"
          variant="outline-success"
        >
          {{ $t("deleteBtnText") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js";

export default {
  name: "DeleteModal",
  data() {
    return {
      showDeleteModal: false,
      selectedRowIndex: null,
      selectedRowId: null,
    };
  },
  created() {
    this.initialData();
    EventBus.$off("onShowDeletModal");
    EventBus.$on("onShowDeletModal", (data, eleData) => {
      this.selectedRowIndex = data;
      this.showDeleteModal = true;
      this.selectedRowId = eleData.id;
    });
  },
  methods: {
    onDeleteRow(index) {
      EventBus.$emit("deletedRow", index, this.selectedRowId);
      this.showDeleteModal = false;
    },

    initialData() {
      this.selectedRowIndex = null;
      this.selectedRowId = null;
    },
  },
};
</script>

<style></style>
